import {
  Activity,
  Users,
  CreditCard,
  BarChart2,
  Wifi,
  Clock,
  FileText,
  Cpu,
  Shield,
  DollarSign,
  Headphones,
  Settings,
  Home,
  Briefcase,
  Link as LinkIcon,
  MessageSquare,
  Calendar,
  BookOpen,
  Video,
  Layout,
  Bell,
  PieChart,
  Archive,
} from "react-feather";

export const MENUITEMS = [
  // ─── PLATFORM ADMIN ────────────────────────────────────────────────────────
  {
    menutitle: "Platform Admin",
    menucontent: "MeetingHub AI platform controls",
    portalType: "platform", // used to conditionally render in sidebar
    Items: [
      {
        title: "Platform Dashboard",
        icon: Activity,
        path: `${process.env.PUBLIC_URL}/platform/dashboard`,
        type: "link",
        active: false,
      },
      {
        title: "Tenants",
        icon: Users,
        path: `${process.env.PUBLIC_URL}/platform/tenants`,
        type: "link",
        active: false,
      },
      {
        title: "Subscriptions",
        icon: CreditCard,
        path: `${process.env.PUBLIC_URL}/platform/subscriptions`,
        type: "link",
        active: false,
      },
      {
        title: "Usage & Quotas",
        icon: BarChart2,
        path: `${process.env.PUBLIC_URL}/platform/usage`,
        type: "link",
        active: false,
      },
      {
        title: "Integrations Monitor",
        icon: Wifi,
        path: `${process.env.PUBLIC_URL}/platform/integrations`,
        type: "link",
        active: false,
      },
      {
        title: "Jobs & Failures",
        icon: Clock,
        path: `${process.env.PUBLIC_URL}/platform/jobs`,
        type: "link",
        active: false,
      },
      {
        title: "Meetings",
        icon: Video,
        path: `${process.env.PUBLIC_URL}/platform/meetings`,
        type: "link",
        active: false,
      },
      {
        title: "Global Templates",
        icon: FileText,
        path: `${process.env.PUBLIC_URL}/platform/templates`,
        type: "link",
        active: false,
      },
      {
        title: "AI Policies",
        icon: Cpu,
        path: `${process.env.PUBLIC_URL}/platform/ai-policies`,
        type: "link",
        active: false,
      },
      {
        title: "Audit & Security",
        icon: Shield,
        path: `${process.env.PUBLIC_URL}/platform/audit`,
        type: "link",
        active: false,
      },
      {
        title: "Billing",
        icon: DollarSign,
        path: `${process.env.PUBLIC_URL}/platform/billing`,
        type: "link",
        active: false,
      },
      {
        title: "Support Tools",
        icon: Headphones,
        path: `${process.env.PUBLIC_URL}/platform/support`,
        type: "link",
        active: false,
      },
      {
        title: "System Settings",
        icon: Settings,
        path: `${process.env.PUBLIC_URL}/platform/settings`,
        type: "link",
        active: false,
      },
    ],
  },

  // ─── COMPANY ADMIN ─────────────────────────────────────────────────────────
  {
    menutitle: "Company Admin",
    menucontent: "Acme Oman LLC administration",
    portalType: "company", // used to conditionally render in sidebar
    Items: [
      {
        title: "Dashboard",
        icon: Home,
        path: `${process.env.PUBLIC_URL}/company/dashboard`,
        type: "link",
        active: false,
      },
      {
        title: "Users & Roles",
        icon: Users,
        path: `${process.env.PUBLIC_URL}/company/users`,
        type: "link",
        active: false,
      },
      {
        title: "Departments",
        icon: Briefcase,
        path: `${process.env.PUBLIC_URL}/company/departments`,
        type: "link",
        active: false,
      },
      {
        title: "Integrations",
        icon: LinkIcon,
        path: `${process.env.PUBLIC_URL}/company/integrations`,
        type: "link",
        active: false,
      },
      {
        title: "Channels",
        icon: MessageSquare,
        path: `${process.env.PUBLIC_URL}/company/channels`,
        type: "link",
        active: false,
      },
      {
        title: "Scheduling Rules",
        icon: Calendar,
        path: `${process.env.PUBLIC_URL}/company/scheduling`,
        type: "link",
        active: false,
      },
      {
        title: "Attendee Directory",
        icon: BookOpen,
        path: `${process.env.PUBLIC_URL}/company/directory`,
        type: "link",
        active: false,
      },
      {
        title: "Meetings",
        icon: Video,
        path: `${process.env.PUBLIC_URL}/company/meetings`,
        type: "link",
        active: false,
      },
      // {
      //   title: "Transcripts & MOM",
      //   icon: FileText,
      //   path: `${process.env.PUBLIC_URL}/company/transcripts`,
      //   type: "link",
      //   active: false,
      // },
      {
        title: "Templates",
        icon: Layout,
        path: `${process.env.PUBLIC_URL}/company/templates`,
        type: "link",
        active: false,
      },
      {
        title: "Notifications",
        icon: Bell,
        path: `${process.env.PUBLIC_URL}/company/notifications`,
        type: "link",
        active: false,
      },
      {
        title: "Reports",
        icon: PieChart,
        path: `${process.env.PUBLIC_URL}/company/reports`,
        type: "link",
        active: false,
      },
      {
        title: "Audit Logs",
        icon: Archive,
        path: `${process.env.PUBLIC_URL}/company/audit`,
        type: "link",
        active: false,
      },
      {
        title: "Company Settings",
        icon: Settings,
        path: `${process.env.PUBLIC_URL}/company/settings`,
        type: "link",
        active: false,
      },
    ],
  },
];
